import React from 'react';
import Select from "./Select";
import {useTranslation} from "react-i18next";

const SeatMembershipSelector = ({value, setValue, disabled, required}) => {
    const {t} = useTranslation();

    return <Select
        label={t('seat_membership_reserved_lbl')}
        value={value}
        onChange={e => setValue(e.target.value)}
        optionKey='Key'
        optionValue='Value'
        helperText={t('seat_membership_reserved_helperText')}
        options={[
            {Key: 'Y', Value: t('seat_membership_y')},
            {Key: 'N', Value: t('seat_membership_n')},
        ]}
        inputProps={{
            disabled: disabled,
            variant: 'outlined',
            fullWidth: true,
            required: required
        }}
    />;
};

export default SeatMembershipSelector;
